import LocalStorageRepository from '@/domain/repository/LocalStorageRepository';

const logoutUseCase = async () => {
  LocalStorageRepository.removeCredentials();
};

export default logoutUseCase;